import type { Bounds } from '@ipfabric/utils';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { option } from 'fp-ts';
import type { Option } from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';
import { BoundsCalculator } from 'utils/pixi/BoundsCalculator';

export const boundsObserver: GraphRendererPlugin = (pluginInterface) => {
  const boundsCalculator = new BoundsCalculator();
  boundsCalculator.addListener('change', (event) => {
    pluginInterface.events.emit('graphBoundsChange', event);
  });

  const updateBounds = (maybeBounds: Option<Bounds>, elementName: string) => {
    pipe(
      maybeBounds,
      option.fold(
        () => {
          boundsCalculator.removeObjectBounds(elementName);
        },
        (bounds) => {
          boundsCalculator.setObjectBounds(elementName, bounds);
        },
      ),
    );
  };

  pluginInterface.events.addListener('boxBoundsChange', ({ boxId, bounds }) => {
    updateBounds(bounds, `box/${boxId}`);
  });

  pluginInterface.events.addListener('nodeBoundsChange', ({ node, bounds }) => {
    updateBounds(bounds, node.name);
  });

  pluginInterface.events.addListener('edgeBoundsChange', ({ edge, bounds }) => {
    updateBounds(bounds, edge.name);
  });
};
